import { ContractVersionPageContractVersionFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import Item from './Item'

interface Props {
  contractVersion: ContractVersionPageContractVersionFragment
  canEdit?: boolean
}

const WorkingDayType = ({ contractVersion, canEdit = false }: Props) => {
  if (contractVersion.country !== 'fr' && contractVersion.country !== 'es') return null

  const workingDayType =
    contractVersion.country == 'fr'
      ? contractVersion.franceWorkingDayType?.name
      : contractVersion.spainWorkingDayType?.name

  if (!workingDayType && !canEdit) return null

  return (
    <Item
      id="working_day_type"
      title={i18n.t('contract_versions.time.working_day_type')}
      description={workingDayType}
    />
  )
}

export default WorkingDayType
